export const JSM_BASE_URL = 'https://jsd-widget.atlassian.com/api/embeddable/';
export const PORTAL_PROXY_BASE_URL = 'https://upload.brandportal.de/jsm/';

// should have value proper for Content-Language HTTP header; but pay attention to extra spaces...
export const PORTAL_PROXY_TOKEN = 'en-GB; q=1,  en;q=0.8';

// in JSM seems to be a hard coded limit of 5 MB pro file
export const JSM_MAX_FILE_SIZE = 5 * 1000 * 1000;
